import { Accordion, AccordionProps } from '@mantine/core';
import { ReactComponent as ArrowRight } from '@assets/svg/arrow-right.svg';
import { useStyles } from './FilterAccordion.styles';

export function FilterAccordion<Multiple extends boolean = false>(
  props: AccordionProps<Multiple>,
) {
  const { children, ...rest } = props;

  const { classes } = useStyles();
  const { root, ...restclasses } = classes;
  return (
    <Accordion
      {...rest}
      classNames={restclasses}
      className={root}
      chevron={<ArrowRight />}
      chevronSize={16}
    >
      {children}
    </Accordion>
  );
}
